import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697c8dd9921dc9001460a629/travelgateway/src/app/audit-logs/components/AuditLogsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697c8dd9921dc9001460a629/travelgateway/src/components/common/Header.tsx");
